exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-qa__Wrap {\n  text-align: center;\n}\n.upload-qa__Wrap .upload-trigger__Span {\n  cursor: pointer;\n  display: block;\n  margin-bottom: 24px;\n  width: 120px;\n  height: 40px;\n  background: #1cc4f8;\n  border-radius: 6px;\n  text-align: center;\n  line-height: 40px;\n  font-size: 14px;\n  font-weight: normal;\n  color: #ffffff;\n}\n.upload-qa__Wrap .upload-status {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 14px;\n}\n.upload-qa__Wrap .upload-status.success {\n  color: #0FD9AE;\n}\n.upload-qa__Wrap .upload-status.fail {\n  color: #ff8351;\n}\n", ""]);

// exports
